/* dual-currency-eur.js — v22 (writes EUR into BOTH cart totals cells: mobile + desktop) */
(function () {
  if (window.__dualEURv22) return; window.__dualEURv22 = true;

  var PEG = 1.95583; // 1 EUR = 1.95583 BGN
  var isRendering = false, rafId = 0;

  function toEURCents(bgnCents){ return Math.round(bgnCents / PEG); }
  function fmtEUR(c){ var a=c/100; try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:'EUR'}).format(a);}catch(e){ return (Math.round(a*100)/100).toFixed(2)+' EUR'; } }
  function parseBGNCentsFromNode(node){
    if (!node) return NaN;
    var attr = parseInt(node.getAttribute('data-price-cents'), 10);
    if (isFinite(attr)) return attr;
    var t=(node.textContent||'').replace(/\u00A0/g,' ')
                                 .replace(/\s+/g,'')
                                 .replace(/(BGN|лв|LEV|LV|€|EUR)/gi,'')
                                 .replace(',','.');
    var m=t.match(/(\d+(\.\d{1,2})?)/);
    return m ? Math.round(parseFloat(m[1])*100) : NaN;
  }
  function makeEURLike(baseEl, cents){
    var s=document.createElement('span');
    if (baseEl && baseEl.classList && !baseEl.classList.contains('product-option')) {
      s.className = baseEl.className;           // copy typography
    }
    s.classList.add('dual-eur');                // spacing hook only
    s.textContent = ' · ' + fmtEUR(toEURCents(cents));
    return s;
  }

  /* -------- product page placeholders -------- */
  function renderProductPlaceholders(root){
    (root||document).querySelectorAll('.price-item--converted[data-from="BGN"][data-to="EUR"]').forEach(function(el){
      var cents=parseInt(el.getAttribute('data-price-cents'),10);
      if (isFinite(cents)) el.textContent='· ' + fmtEUR(toEURCents(cents));
    });
  }

  /* -------- cart page / drawer -------- */
  function leftBase(item){
    var details=item.querySelector('.cart-item__details'); if (!details) return null;
    return Array.from(details.querySelectorAll('.product-option')).find(function(el){
      var txt=(el.textContent||'').trim();
      return txt && /\d/.test(txt) && txt.indexOf(':')===-1;
    }) || null;
  }

  // For each totals cell (mobile + desktop), pick the last visible price container and append inside it
  function writeEURIntoTotalsCell(cell){
    if (!cell) return;
    // remove only our old EUR in this cell
    cell.querySelectorAll(':scope .dual-eur').forEach(function(n){ n.remove(); });

    var priceBoxes = Array.from(cell.querySelectorAll('.price.price--end'))
      .filter(function(el){ return !el.closest('s'); }); // ignore struck-through old price
    if (!priceBoxes.length) return;
    var box = priceBoxes[priceBoxes.length - 1];

    var cents = parseBGNCentsFromNode(box);
    if (!isFinite(cents)) return;

    box.insertAdjacentElement('beforeend', makeEURLike(box, cents)); // INSIDE so it sits on one line
  }

  function renderCart(root){
    root = root || document;
    isRendering = true;

    root.querySelectorAll('.cart-item').forEach(function(item){
      // clean all our EUR in this row
      item.querySelectorAll('.dual-eur').forEach(function(n){ n.remove(); });

      // LEFT under title
      var lb = leftBase(item);
      if (lb){
        var lc = parseBGNCentsFromNode(lb);
        if (isFinite(lc)) lb.insertAdjacentElement('beforeend', makeEURLike(lb, lc));
      }

      // RIGHT totals cells: mobile + desktop
      var totalsCells = item.querySelectorAll('.cart-item__totals');
      totalsCells.forEach(writeEURIntoTotalsCell);
    });

    // Subtotal / total (bottom, drawer) — keep EUR INSIDE the value to avoid wrapping
    root.querySelectorAll('.totals__subtotal-value, .totals__total-value, #CartDrawer .totals__subtotal-value, #CartDrawer .totals__total-value')
      .forEach(function(node){
        node.querySelectorAll(':scope > .dual-eur').forEach(function(n){ n.remove(); });
        var cents=parseBGNCentsFromNode(node);
        if (isFinite(cents)) node.insertAdjacentElement('beforeend', makeEURLike(node, cents));
      });

    isRendering = false;
  }

  function render(root){ try{renderProductPlaceholders(root);}catch(e){} try{renderCart(root);}catch(e){} }
  function scheduleRender(){ if (isRendering) return; if (rafId) cancelAnimationFrame(rafId); rafId = requestAnimationFrame(function(){ rafId=0; render(document); }); }

  function attachObservers(){
    var targets = [
      document.body,
      document.querySelector('#main-cart-items'),
      document.querySelector('#main-cart-footer'),
      document.querySelector('.cart__footer'),
      document.querySelector('#CartDrawer'),
      document.querySelector('cart-drawer'),
      document.querySelector('cart-drawer-items')
    ].filter(Boolean);

    (window.__dualEUR_obs||[]).forEach(function(o){ try{o.disconnect();}catch(e){}; });
    window.__dualEUR_obs = [];

    targets.forEach(function(t){
      try{
        var obs = new MutationObserver(function(muts){
          var ignore = muts.every(function(m){
            if (m.type==='characterData' && m.target.parentElement && m.target.parentElement.classList.contains('dual-eur')) return true;
            var nodes=[].concat(Array.from(m.addedNodes||[]), Array.from(m.removedNodes||[]));
            return nodes.length && nodes.every(function(n){ return n.nodeType===1 && n.classList && n.classList.contains('dual-eur'); });
          });
          if (!ignore) scheduleRender();
        });
        obs.observe(t, { childList:true, subtree:true, characterData:true });
        window.__dualEUR_obs.push(obs);
      }catch(e){}
    });

    // common cart events
    ['shopify:section:load','cart:refresh','cart:updated','cart:change','cart:remove','update:cart','ajaxCart:updated','cart:requestComplete']
      .forEach(function(evt){ document.addEventListener(evt, scheduleRender); });

    document.addEventListener('input',  function(e){ if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) scheduleRender(); }, true);
    document.addEventListener('change', function(e){ if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) scheduleRender(); }, true);
    document.addEventListener('click',  function(e){
      var el = e.target.closest('button[name="remove"], .cart-remove-button, button[form="CartDrawer-RemoveItem"]');
      if (el) scheduleRender();
    }, true);
  }

  if (document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', function(){ render(document); attachObservers(); }, { once:true });
  } else {
    render(document); attachObservers();
  }

  // product page variant changes
  document.addEventListener('variant:change', function(e){
    var v=e.detail && e.detail.variant; if (!v) return;
    document.querySelectorAll('.price-item--converted[data-from="BGN"][data-to="EUR"]').forEach(function(el){ el.setAttribute('data-price-cents', v.price); });
    scheduleRender();
  });
})();
